// Sort-stable add/remove for numeric multi-select. Keeps the URL
// representation deterministic regardless of click order.
export function toggleNumeric(arr: number[], value: number): number[] {
  if (arr.includes(value)) return arr.filter((v) => v !== value);
  return [...arr, value].sort((a, b) => a - b);
}

// String-typed equivalent for the canonical-ordered enums (statuses /
// types). Order is preserved in `parseFilterState` after re-sort, so
// we don't need to re-sort here.
export function toggleStringMember<T extends string>(arr: T[], value: T): T[] {
  if (arr.includes(value)) return arr.filter((v) => v !== value);
  return [...arr, value];
}

export function addDaysYmd(ymd: string, days: number): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd);
  if (!m) return ymd;
  const dt = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  dt.setUTCDate(dt.getUTCDate() + days);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(dt.getUTCDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}
